'use strict';

/* globals $ */

var _ = require('lodash');
var React = require('react');
var ReactDOM = require('react-dom');

var maxRuns = require('../utils/max-runs');


// var refererPaginatedMatcher = /\.*feed\/pagina-.[0-9]*\.html$/;
var urlEndReplacer = /(\/|\.html)$/;
var nextPageCardRender = false;


var LoadMore = {

    loadMore: {
        autoLoadMoreDistance: 1000,
        throttler: null,
        timer: null
    },

    componentDidMount: function() {
        this.turnAutoLoadMoreOn();
    },

    componentWillUnmount: function() {
        this.turnAutoLoadMoreOff();
    },

    renderLoadMore: function(referer) {
        var nextPage = '';
        var nextPageNumber;

        if (this.hasNextPage() === false) {
            this.turnAutoLoadMoreOff();
            return null;
        }

        nextPageNumber = this.getNextPageIndex();
        if (referer && nextPageNumber) {
            nextPage = referer.replace(urlEndReplacer, '') +
                        '/feed/pagina-' +
                        nextPageNumber +
                        '.html';
        }

        return (
            <div className="load-more gui-color-primary-bg">
                <a href={nextPage}
                   ref="loadMore"
                   onClick={this.handleLoadMore}>
                    Veja mais
                </a>
            </div>
        );
    },

    handleLoadMore: function(event) {
        event.preventDefault();

        if (nextPageCardRender && this.cardStore)
            this.cardStore.turnImmediateRenderOff();

        var newItems = this.buildPage();

        // tenta de novo (solução provisória)
        if (_.isEmpty(newItems)) {
            newItems = this.buildPage();
        }

        if (_.isEmpty(newItems) === false) {
            this.itemStore.dispatch({
                eventName: 'add',
                items: newItems
            });
        }

        // window.history.pushState({}, "", this.getNextPageUrl());
    },

    getNextPageUrl: function() {
        return ReactDOM.findDOMNode(this.refs.loadMore).getAttribute('href');
    },

    turnAutoLoadMoreOn: function() {
        if (this.hasNextPage() === false) return;

        var maxClicks = 3;
        if (this.isRecommended()) maxClicks = 5;

        var limited = maxRuns({
                max: maxClicks,
                context: this,
                target: this.autoLoadMore,
                onFinish: this.turnAutoLoadMoreOff
        });
        var throttler = _.throttle(limited, 1000, {
          trailing: false
        });

        this.loadMore.throttler = throttler;
        this.dom.$window.on('scroll.feed', throttler);
        this.loadMore.timer = setInterval(throttler, 1000);
        this.autoLoadMoreActive = true;
    },

    autoLoadMore: function() {
        var scrollTop = this.dom.$window.scrollTop();
        var viewportHeight = this.dom.$window.height();
        var loadMoreElement = this.refs.loadMore;
        var offsetTop = $(loadMoreElement).offset().top;
        var distance = this.loadMore.autoLoadMoreDistance;

        if (scrollTop + viewportHeight + distance > offsetTop) {
            this.pauseAutoLoadMore();
            loadMoreElement.click();
            return true;
        }

        return false;
    },

    turnAutoLoadMoreOff: function() {
        var throttler = this.loadMore.throttler;

        if (typeof(throttler) === 'function') {
            this.loadMore.throttler = null;
            this.dom.$window.off('scroll.feed', throttler);
            throttler.cancel();
            clearInterval(this.loadMore.timer);
            this.autoLoadMoreActive = false;
        }
    },

    pauseAutoLoadMore: function() {
        var throttler = this.loadMore.throttler;
        if (typeof(throttler) === 'function') {
            this.loadMore.throttler = null;
            this.throttledAutoLoadMore = throttler;
            this.dom.$window.off('scroll.feed', throttler);
        }
    },

    playAutoLoadMore: function() {
        var throttler = this.throttledAutoLoadMore;
        if (typeof(throttler) === 'function') {
            this.loadMore.throttler = throttler;
            this.dom.$window.on('scroll.feed', throttler);
        }
    },

    isAutoLoadMoreActive: function() {
        return this.autoLoadMoreActive;
    }
};

module.exports = LoadMore;
